module.exports = __webpack_public_path__ + "img/no-account.0cd1ab97.png";